module.exports = __webpack_public_path__ + "img/shapp.3c33de7d.png";